import comp from "./ActionTableV2";
export default comp;
